import { render, staticRenderFns } from "./change-phone.vue?vue&type=template&id=2ef24eae&scoped=true&"
import script from "./change-phone.vue?vue&type=script&lang=js&"
export * from "./change-phone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef24eae",
  null
  
)

export default component.exports